export default __webpack_public_path__ + "static/media/905.abb0fb1f.png";